import { Outlet } from 'react-router-dom'

const Location = () => <Outlet />

export default Location
